import Modernizr from "modernizr";
import $ from "jquery";
import "slick-carousel";
import "lazysizes";
import "lazysizes/plugins/parent-fit/ls.parent-fit";
import IMask from "imask";
import "@fancyapps/fancybox";
import mixitup from 'mixitup';

const isMobile = /Mobile|webOS|BlackBerry|IEMobile|MeeGo|mini|Fennec|Windows Phone|Android|iP(ad|od|hone)/i.test(navigator.userAgent);
let bgVariables = {
  sm: "-sm",
  ratio: "@2x",
  exe: "jpg"
};
document.addEventListener("lazybeforeunveil", function(e){
  let bg = e.target.getAttribute("data-bg");
  if(bg){
    Modernizr.on( "webp", function( result ) {
      if ( result ) {
        bgVariables.exe = "webp";
        if(window.devicePixelRatio > 1) {
          // десктоп и планшент
          if(window.screen.width > 600) {
            e.target.style.backgroundImage = `url('${bg}${bgVariables.ratio}.${bgVariables.exe}')`;
          } else {
            e.target.style.backgroundImage = `url('${bg}${bgVariables.sm}${bgVariables.ratio}.${bgVariables.exe}')`;
          }

        } else {
          if(window.screen.width > 600) {
            e.target.style.backgroundImage = `url('${bg}.${bgVariables.exe}')`;
          } else {
            e.target.style.backgroundImage = `url('${bg}${bgVariables.sm}.${bgVariables.exe}')`;
          }
        }

      } else {
        if(window.devicePixelRatio > 1) {
          // десктоп и планшент
          if(window.screen.width > 600) {
            e.target.style.backgroundImage = `url('${bg}${bgVariables.ratio}.${bgVariables.exe}')`;
          } else {
            e.target.style.backgroundImage = `url('${bg}${bgVariables.sm}${bgVariables.ratio}.${bgVariables.exe}')`;
          }

        } else {
          if(window.screen.width > 600) {
            e.target.style.backgroundImage = `url('${bg}.${bgVariables.exe}')`;
          } else {
            e.target.style.backgroundImage = `url('${bg}${bgVariables.sm}.${bgVariables.exe}')`;
          }
        }
      }
    });
  }
});
window.lazySizesConfig = {loadHidden: false};

$(document).ready(function () {

  //Update Header Style and Scroll to Top
  function headerStyle() {
    if ($('.main-header').length) {
      var windowpos = $(window).scrollTop();
      var siteHeader = $('.main-header');
      var siteHeaderHeight = $('.main-header').height();
      if (windowpos >= siteHeaderHeight) {
        siteHeader.addClass('fixed-header');
      } else {
        siteHeader.removeClass('fixed-header');
      }
    }
  }

  headerStyle();

  $(window).on('scroll', function () {
    headerStyle();
  });
  window.lazySizesConfig = {loadHidden: false};

  let phoneInput = document.querySelectorAll("input[type=tel]");

  Array.prototype.forEach.call(phoneInput, function (element) {
    let phoneMask = new IMask(element, {
      mask: "+{0}(000)000-00-00",
      lazy: true,
      placeholderChar: "_"
    });
  });
  /*Fiz 100vh*/

  // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
  let vh = window.innerHeight * 0.01;
// Then we set the value in the --vh custom property to the root of the document
  document.documentElement.style.setProperty('--vh', `${vh}px`);

// We listen to the resize event
  window.addEventListener('resize', () => {
    // We execute the same script as before
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  });


  /*==========FANCYBOX SETTINGS==============*/

  $('[data-fancybox]').fancybox({
    loop: true,
    infobar: false,
    backFocus: false
  });

  const ARROW_LEFT_ICON = '<svg class="icon icon-arrow-left" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 492 492"><path d="M198.6 246.1L382.67 62.04a26.68 26.68 0 007.86-19.02 26.7 26.7 0 00-7.86-19.04L366.54 7.86C361.48 2.8 354.7 0 347.5 0s-13.96 2.8-19.02 7.86L109.33 227.01a26.69 26.69 0 00-7.85 19.08 26.69 26.69 0 007.85 19.11l218.94 218.94A26.7 26.7 0 00347.3 492c7.21 0 13.97-2.8 19.04-7.86l16.12-16.12a26.95 26.95 0 000-38.06L198.61 246.1z"/> </svg>';
  const ARROW_RIGHT_ICON = '<svg class="icon icon-arrow-right" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 492 492"><path d="M382.68 226.8L163.73 7.86C158.67 2.79 151.91 0 144.7 0s-13.97 2.8-19.03 7.86l-16.13 16.12a26.95 26.95 0 000 38.06L293.4 245.9 109.34 429.96a26.74 26.74 0 00-7.86 19.03c0 7.21 2.8 13.97 7.86 19.04l16.12 16.11c5.07 5.07 11.83 7.86 19.03 7.86s13.97-2.79 19.04-7.86L382.68 265a26.76 26.76 0 007.85-19.09 26.75 26.75 0 00-7.85-19.1z"/></svg>';

  $('.js-main-slider').slick({
    speed: 300,
    slidesToShow: 1,
    prevArrow: `<button class="slick-arrow slick-arrow--prev" type="button">${ARROW_LEFT_ICON}</button>`,
    nextArrow: `<button class="slick-arrow slick-arrow--next" type="button">${ARROW_RIGHT_ICON}</button>`
  });

  $('.js-brands-carousel').slick({
    variableWidth: true,
    prevArrow: `<button class="slick-arrow slick-arrow--prev" type="button">${ARROW_LEFT_ICON}</button>`,
    nextArrow: `<button class="slick-arrow slick-arrow--next" type="button">${ARROW_RIGHT_ICON}</button>`
  });

  $('.categories-carousel').slick({
    slidesToShow: 6,
    prevArrow: `<button class="slick-arrow slick-arrow--prev" type="button">${ARROW_LEFT_ICON}</button>`,
    nextArrow: `<button class="slick-arrow slick-arrow--next" type="button">${ARROW_RIGHT_ICON}</button>`,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  $('.four-item-carousel').slick({
    slidesToShow: 4,
    prevArrow: `<button class="slick-arrow slick-arrow--prev" type="button">${ARROW_LEFT_ICON}</button>`,
    nextArrow: `<button class="slick-arrow slick-arrow--next" type="button">${ARROW_RIGHT_ICON}</button>`,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  $('.related-products-carousel').slick({
    slidesToShow: 4,
    prevArrow: `<button class="slick-arrow slick-arrow--prev" type="button">${ARROW_LEFT_ICON}</button>`,
    nextArrow: `<button class="slick-arrow slick-arrow--next" type="button">${ARROW_RIGHT_ICON}</button>`,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  })
  $('.slider-team').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    prevArrow: `<button class="slick-arrow slick-arrow--prev" type="button">${ARROW_LEFT_ICON}</button>`,
    nextArrow: `<button class="slick-arrow slick-arrow--next" type="button">${ARROW_RIGHT_ICON}</button>`,
    asNavFor: '.slider-team-nav',
    responsive: [
      {
        breakpoint: 767,
        settings: {
          arrows: false
        }
      }
    ]
  });
  $('.slider-team-nav').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: '.slider-team',
    arrows: false,
    focusOnSelect: true
  });


  /*Табы*/


  $('.tabs').each(function () {
    var $this = $(this),
      $tab_nav = $this.find('.tab-nav'),
      $tab_nav_item = $this.find('.tab-nav > ul > li'),
      $lamp = $this.find('.lamp'),
      $tab_body = $(this).find('.tab');
    $tab_nav_item.first().addClass('active');
    var current_tab = $tab_nav.find('.active a').attr('href');
    $(current_tab).addClass('is-active');
    var currentleft = $tab_nav.find('.active').position().left + "px";
    var currentwidth = $tab_nav.find('.active').css('width');
    $lamp.css({"left": currentleft, "width": currentwidth});

    $tab_nav_item.on('mouseover', function () {
      $tab_nav_item.removeClass('active');
      $(this).addClass('active');
      var currentleft = $tab_nav.find('.active').position().left + "px";
      var currentwidth = $tab_nav.find('.active').css('width');
      $lamp.css({"left": currentleft, "width": currentwidth});
    });
    $tab_nav_item.on('mouseleave', function () {
      $tab_nav_item.removeClass('active');
      $(this).parent().siblings().find('is-current').addClass('active');
      var currentleft = $tab_nav.find('.is-current').position().left + "px";
      var currentwidth = $tab_nav.find('.is-current').css('width');
      $lamp.css({"left": currentleft, "width": currentwidth});
    });
    $tab_nav_item.on('click', 'a', function (e) {
      e.preventDefault();
      $(this).parent().siblings().removeClass('is-current');
      $(this).parent().addClass('is-current');
      $(this).parent().addClass('active');
      current_tab = $(this).attr('href');
      $(current_tab).siblings().removeClass('is-active');
      $(current_tab).addClass('is-active');
    });
  });


  /*Модальные окна*/

  $(document).on('click', '.js-modal', function (e) {
    e.preventDefault();
    var modal_id;
    if ($(this).attr('data-modal') != undefined) {
      modal_id = $(this).attr('data-modal');
    }
    else {
      modal_id = $(this).attr('href');
    }
    $(modal_id).addClass('open');
    $('body').append('<div class="modal-overlay"></div>');
    $('html').addClass('lock-screen');
  });

  $(document).on('click', '.js-close-modal', function (e) {
    e.preventDefault();
    $(this).parents('.modal').removeClass('open');
    $('html').removeClass('lock-screen');
    $('.modal-overlay').remove();


  });

  $(document).keyup(function (e) {
    if (e.key === "Escape") { // escape key maps to keycode '27'
      $('.modal').removeClass('open');
      $('html').removeClass('lock-screen');
      $('.modal-overlay').remove();
    }
  });

  $(document).mouseup(function (e) {
    var container = $('.modal');
    if (container.has(e.target).length === 0) {
      $('.modal').removeClass('open');
      $('html').removeClass('lock-screen');
      $('.modal-overlay').remove();
    }
  });


  /*Scroll top button*/
  const btnScrollTop = $('#button-scroll-top');

  $(window).scroll(function () {
    if ($(window).scrollTop() > 300) {
      btnScrollTop.addClass('show');
    } else {
      btnScrollTop.removeClass('show');
    }
  });

  btnScrollTop.on('click', function (e) {
    e.preventDefault();
    $('html, body').animate({scrollTop: 0}, '300');
  });

  //Tabs Box
  if ($('.tabs-box').length) {
    $('.tabs-box .tab-buttons .tab-btn').on('click', function (e) {
      e.preventDefault();
      var target = $($(this).attr('data-tab'));

      if ($(target).is(':visible')) {
        return false;
      } else {
        target.parents('.tabs-box').find('.tab-buttons').find('.tab-btn').removeClass('active-btn');
        $(this).addClass('active-btn');
        target.parents('.tabs-box').find('.tabs-content').find('.tab').fadeOut(0);
        target.parents('.tabs-box').find('.tabs-content').find('.tab').removeClass('active-tab');
        $(target).fadeIn(300);
        $(target).addClass('active-tab');
      }
    });
  }
  let containerEl = document.querySelector('.filter-list');
  if (containerEl) {
    let mixer = mixitup(containerEl, {
      animation: {
        duration: 300
      }
    });
  }

if($(window).width() < 992) {
  $(document).on('click', '.js-category-toggle', function (e) {
    e.preventDefault();
    $(this).parents('.sidebar-blog-category').find('.js-category').fadeIn();
  });

  $(document).mouseup(function (e) {
    var container = $('.js-category');
    if (container.has(e.target).length === 0) {
      $('.js-category').fadeOut();
    }
  });
}


  /*Map lazy load*/

  //Ymap start
  let spinner = $('.preloader');
  let check_if_load = 0;

  function init() {

    let mapFooter = new ymaps.Map('map', {
      center: [55.76, 37.64],
      zoom: 10,
      controls: ['smallMapDefaultSet']
    });

    // Отклюаем зум на карте
    mapFooter.behaviors.disable('scrollZoom');

    let objectManagerFooter = new ymaps.ObjectManager();

    objectManagerFooter.objects.options.set({
      // Опции.
      iconLayout: 'default#image',
      iconImageOffset: [-25, -50],
      iconImageSize: [78, 111],
      hideIconOnBalloonOpen: false,
      iconImageHref: "img/icons/map-marker.png",
      balloonShadow: false,
      balloonPanelMaxMapArea: 0
    });
    mapFooter.geoObjects.add(objectManagerFooter);


    let layer = mapFooter.layers.get(0).get(0);
    waitForTilesLoad(layer).then(function () {
      spinner.fadeOut();
      $.ajax({
        url: "js/map.json"
      }).done(function (data) {
        objectManagerFooter.add(data);
        mapFooter.setBounds(mapFooter.geoObjects.add(objectManagerFooter).getBounds(), {checkZoomRange: true});
      });

    });


  }

  function waitForTilesLoad(layer) {
    return new ymaps.vow.Promise(function (resolve, reject) {
      let tc = getTileContainer(layer), readyAll = true;
      tc.tiles.each(function (tile, number) {
        if (!tile.isReady()) {
          readyAll = false;
        }
      });
      if (readyAll) {
        resolve();
      } else {
        tc.events.once("ready", function () {
          resolve();
        });
      }
    });
  }

  function getTileContainer(layer) {
    for (let k in layer) {
      if (layer.hasOwnProperty(k)) {
        if (
          layer[k] instanceof ymaps.layer.tileContainer.CanvasContainer
          || layer[k] instanceof ymaps.layer.tileContainer.DomContainer
        ) {
          return layer[k];
        }
      }
    }
    return null;
  }

  function loadScript(url, callback) {

    var script = document.createElement("script");

    if (script.readyState) {  //IE
      script.onreadystatechange = function () {
        if (script.readyState == "loaded" ||
          script.readyState == "complete") {
          script.onreadystatechange = null;
          callback();
        }
      };
    } else {
      script.onload = function () {
        callback();
      };
    }

    script.src = url;
    document.getElementsByTagName("head")[0].appendChild(script);
  }


  let ymap = function () {
    $(window).scroll(function () {
        if (check_if_load == 0) {
          check_if_load = 1;
          spinner.addClass('is-active');
          loadScript("https://api-maps.yandex.ru/2.1/?lang=ru_RU&apikey=72fefb6c-2a67-40e4-8066-78f0495d0ff8", function () {
            ymaps.load(init);
          });
        }
    });
  }

  if ($('.map').length) {
    ymap();
  }

  if ($(window).width() < 1200) {
    $('.main-menu__item.dropdown').append('<button type="button" class="collapse-sub-menu"></button>')
  }
  $(document).on("click", ".toggle-menu__icon", function () {
    $('.main-header__menu').addClass('is-active');
    $('.main-header__menu').prepend('<button type="button" class="js-close-menu close-menu"></button>');
    $('body').append('<div class="menu-overlay"></div>')
  });
  $(document).on("click", ".js-close-menu, .menu-overlay", function () {
    $('.main-header__menu').removeClass('is-active');
    $('.js-close-menu').remove();
    $('.menu-overlay').remove();

  });
  $(document).on("click", ".collapse-sub-menu", function () {
    $(this).parent().find('.sub-menu').slideToggle();
  });

  if($(window).width() > 991) {
    let sidebarHeight = $('.js-sticky-sidebar').height();
    let sidebarOffsetTop = $('.js-sticky-sidebar').offset().top;
    let catalogHeight = $('.js-sticky-content').height();
    let catalogOffsetTop = $('.js-sticky-content').offset().top;
    $(window).on('scroll', function () {
      let windowScroll = $(window).scrollTop();
      if (windowScroll > sidebarOffsetTop && windowScroll < (catalogHeight + catalogOffsetTop - sidebarHeight)) {
        $('.js-sticky-sidebar').addClass('is-fix');
        $('.js-sticky-sidebar').css({'transform': `translateY(0px)`});
      }
      else if (windowScroll > (catalogHeight + catalogOffsetTop - sidebarHeight)) {
        $('.js-sticky-sidebar').removeClass('is-fix');
        $('.js-sticky-sidebar').css({'transform': `translateY(${catalogHeight - sidebarHeight}px)`});
      }
      else {
        $('.js-sticky-sidebar').removeClass('is-fix');
        $('.js-sticky-sidebar').css({'transform': `translateY(0)`});
      }
    })
  }

});